import { FC } from 'react'
import { ButtonBase, Box } from '@mui/material'

interface QuickAccessLinkProps {
  href: string
  imgSrc: string
  alt: string
}

const QuickAccessLink: FC<QuickAccessLinkProps> = ({ href, imgSrc, alt }) => {
  return (
    <ButtonBase
      component="a"
      href={href}
      target='_blank'
      rel="noopener noreferrer"
      sx={{
        color: '#666',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        width: { sm: 'auto' },
        borderRadius: '8px',
        padding: '12px',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-3px)',
          backgroundColor: 'rgba(11, 116, 222, 0.05)',
        }
      }}
    >
      <Box
        component="img"
        src={imgSrc}
        alt={alt}
        sx={{
          height: { xs: 30, md: 40 },
          width: 'auto',
          objectFit: 'contain',
          transition: 'opacity 0.2s ease',
        }}
      />
    </ButtonBase>
  )
}

export default QuickAccessLink
